import keyMirror from 'react-utils/keyMirror';
export const ContentProgressTypes = keyMirror({
  COMPLETED: null,
  FAILED: null,
  IN_REVIEW: null,
  STARTED: null
});
export const PracticalExerciseTypes = keyMirror({
  MANUALLY_GRADED_WITH_FILE_SUBMISSION: null
});
export const HUBSPOT_VIDEO_REFERENCE = 'HUBSPOT_VIDEO';
export const ExternalResourceTypes = keyMirror({
  TRANSCRIPT: null,
  SLIDES: null,
  TEMPLATE: null,
  OTHER: null,
  VIDEO: null,
  BLOG_POST: null,
  EBOOK: null,
  TOOL: null,
  REPORT: null,
  GUIDE: null,
  DOWNLOAD: null,
  WORKBOOK: null,
  PROJECT: null,
  TRAINING: null,
  CHECKLIST: null,
  KNOWLEDGE_BASE: null,
  DOCUMENTATION: null,
  ARTICLE: null,
  FAQS: null,
  TUTORIAL: null,
  EXAMPLES: null,
  CASE_STUDY: null,
  CO_BRANDABLE_EBOOK: null,
  GRAPHIC: null,
  TRACK: null,
  LESSON: null,
  PODCAST: null,
  SPREADSHEET: null,
  WEBSITE: null,
  HUBSPOT_COMMUNITY: null,
  SLACK: null,
  USER_GUIDE: null
});